<template>
  <div class="kv">
    <div
      v-for="(row, i) in rows"
      :key="i"
      class="kv-row"
    >
      <input
        v-model="row.k"
        class="kv-key"
        placeholder="name"
        @input="emit"
      >
      <textarea
        v-model="row.v"
        v-autosize
        class="kv-val"
        :placeholder="valuePlaceholder"
        @input="emit"
      />
      <button
        class="kv-remove"
        title="Remove"
        @click="remove(i)"
      >
        ✕
      </button>
    </div>
    <button
      class="kv-add"
      @click="add"
    >
      + {{ addLabel }}
    </button>
  </div>
</template>

<script>
import autosize from '../autosize'

export default {
  name: 'KvEditor',

  directives: { autosize },

  props: {
    // A plain object of string values. Rendered as editable key/value rows.
    value: { type: Object, default: () => ({}) },
    valuePlaceholder: { type: String, default: 'value' },
    addLabel: { type: String, default: 'Add field' }
  },

  data () {
    return { rows: this.toRows(this.value) }
  },

  watch: {
    value (v) {
      this.rows = this.toRows(v)
    }
  },

  methods: {
    toRows (obj) {
      if (!obj || typeof obj !== 'object') return []
      return Object.keys(obj).map(k => ({ k, v: this.asText(obj[k]) }))
    },
    asText (val) {
      if (val === null || val === undefined) return ''
      if (typeof val === 'object') return JSON.stringify(val)
      return String(val)
    },
    emit () {
      const out = {}
      this.rows.forEach(r => {
        const key = (r.k || '').trim()
        if (key) out[key] = r.v
      })
      this.$emit('input', out)
    },
    add () {
      this.rows.push({ k: '', v: '' })
      this.emit()
    },
    remove (i) {
      this.rows.splice(i, 1)
      this.emit()
    }
  }
}
</script>

<style scoped>
.kv-row {
  display: flex;
  gap: 0.6rem;
  margin-bottom: 0.6rem;
  align-items: flex-start;
}
.kv-key {
  width: 16rem;
  flex-shrink: 0;
  border: 1px solid #d5ddd8;
  border-radius: 6px;
  padding: 0.7rem 0.9rem;
  font-size: 1.3rem;
  font-family: inherit;
  color: #2b3a33;
  background: #fff;
  box-sizing: border-box;
}
.kv-val {
  flex: 1;
  min-width: 0;
  border: 1px solid #d5ddd8;
  border-radius: 6px;
  padding: 0.7rem 0.9rem;
  font-size: 1.3rem;
  font-family: inherit;
  color: #2b3a33;
  background: #fff;
  overflow: hidden;
  resize: none;
  min-height: 3.4rem;
  line-height: 1.5;
  box-sizing: border-box;
}
.kv-key:focus, .kv-val:focus {
  outline: none;
  border-color: #46634f;
}
.kv-remove {
  border: none;
  background: #f3f6f4;
  color: #8a9a90;
  border-radius: 4px;
  width: 3rem;
  height: 3.4rem;
  cursor: pointer;
  flex-shrink: 0;
}
.kv-remove:hover {
  background: #fdecea;
  color: #c0392b;
}
.kv-add {
  border: 1px dashed #b7c4cd;
  background: none;
  color: #46634f;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  cursor: pointer;
}
.kv-add:hover {
  background: #f1ffe6;
  border-color: #46634f;
}
</style>
